import * as React from 'react';
import { CardSearchResult } from '../search-results';
import { ResultsPerPage, SearchProvider } from '@elastic/react-search-ui';
import SearchRoot from '../SearchRoot';
import { providerConfig } from '../../helper';
import {
  OpenSearchActiveFilters,
  OpenSearchClearAllFiltersButton,
  OpenSearchPagination,
  OpenSearchResultsCount,
} from '../components';
import { CompactLayoutFilters } from './index';

export default function CompactLayout(props) {
  const {
    connector,
    config = {},
    css = {}
  } = props;
  const {displayOptions, ViewMode, compactMode} = config;
  const {itemsPerPage} = displayOptions;
  const {dropdownLabel, cta} = compactMode;

  return (
    <div className={css?.root}>
      <SearchProvider config={{...providerConfig(config), apiConnector: connector}}>
        <SearchRoot>

          <div className="row filters-row">
            <div className="col">
              <CompactLayoutFilters label={dropdownLabel} facets={config?.facets} sorting={config?.sorting}/>
            </div>

            {cta?.text && cta?.url && (
              <div className="col d-flex align-items-center flex-grow-0">
                <a href={cta.url} className="link-cta text-transform-unset text-nowrap">{cta.text}</a>
              </div>
            )}
          </div>

          <div className='active-filters-panel'>
            <OpenSearchClearAllFiltersButton/>
            <OpenSearchActiveFilters facets={config?.facets}/>
          </div>

          <CardSearchResult displayOptions={ViewMode}/>

          <div className='row search-stats__footer'>
            <div className='col-lg-6 col-sm-12 d-flex align-items-center justify-content-start footer-col'>
              <OpenSearchResultsCount/>
            </div>
            <div className='col-lg-6 col-sm-12 footer-col'>
              <OpenSearchPagination/>
            </div>
          </div>
          <div className='d-none'>
            <ResultsPerPage options={[itemsPerPage]} />
          </div>
        </SearchRoot>
      </SearchProvider>
    </div>
  );
}
